<template>
    <mm-select :options="adv_list" 
    v-bind="$attrs" :value="value" v-on="$listeners"/>
</template>

<script>
export default {
	data(){
		return {
			adv_list:[],
		}
	},
	props:{
		value: {
			require: true,
		},
		filter_list: {
			type: Array,
			default() { return [] }
		}
	},
	watch:{
		async filter_list(list) {
            if(!this.$cache['adv_list']){
                const body = await this.$post('/advertiser/list',{attributes:['adv_id','adv_name','status','account_level']});
                body.rows.sort(this.sortAdv);
                this.$cache['adv_list'] = body.rows.map(v=>{return {value:v['adv_id'],label:v['account_level'].toUpperCase() +':'+v['adv_name']+' ('+v['adv_id']+','+v['status']+')',name:v['adv_name']}});
            }
            const all_adv = this.$cache['adv_list'];
            this.adv_list = all_adv.filter( row => list.indexOf(row.value) === -1);
		}
	},
	methods:{
		sortAdv(x,y){
			return x['account_level'].charCodeAt() - y['account_level'].charCodeAt();
		}
	}
}
</script>